import { render } from "./app-card.vue?vue&type=template&id=4820293c"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/card/app-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4820293c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4820293c', __exports__)) {
    console.log('reload')
    api.reload('4820293c', __exports__)
  }
  
  module.hot.accept("./app-card.vue?vue&type=template&id=4820293c", () => {
    console.log('re-render')
    api.rerender('4820293c', render)
  })

}


export default __exports__